export const VALID_MOM_OPTIONS = [
  "funds",
  "bill_pay",
  "p2p",
  "wires",
  "zelle",
  "loan",
  "ach_payments",
] as const;
